import { AddressFragment } from '../generated/graphql'

export const addressFormat = ({ city, state, street1, street2, zip }: AddressFragment) => {
  if (!street1 || !city) return 'None Available'
  if (street2) {
    return `${street1}, ${street2}, ${city}, ${state} ${zip}`
  }
  return `${street1}, ${city}, ${state} ${zip}`
}
